(function () {
  'use strict';

  function initCompare(root) {
    if (!root || root.dataset.compareReady === 'true') return;
    var media = root.querySelector('[data-compare-media]');
    var after = root.querySelector('[data-compare-after]');
    var range = root.querySelector('[data-compare-range]');
    if (!media || !after || !range) return;

    function setFrameWidth() {
      root.style.setProperty('--compare-frame-width', media.offsetWidth + 'px');
    }

    function setPos(value) {
      var n = Math.max(0, Math.min(100, Number(value)));
      root.style.setProperty('--compare-pos', n + '%');
      range.value = String(n);
    }

    setFrameWidth();
    setPos(range.value || 18);

    range.addEventListener('input', function () {
      setPos(range.value);
    });

    // Pointer drag anywhere on the media (range already covers it, but keep resize sync)
    window.addEventListener('resize', setFrameWidth);

    // Soft intro: nudge open a little on first view
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var start = Number(range.value) || 18;
      var played = false;
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || played) return;
            played = true;
            var from = Math.max(8, start - 6);
            var to = Math.min(34, start + 10);
            setPos(from);
            var t0 = null;
            var dur = 900;
            function tick(ts) {
              if (t0 == null) t0 = ts;
              var p = Math.min(1, (ts - t0) / dur);
              var eased = 1 - Math.pow(1 - p, 3);
              setPos(from + (to - from) * eased);
              if (p < 1) requestAnimationFrame(tick);
            }
            requestAnimationFrame(tick);
            io.disconnect();
          });
        },
        { threshold: 0.35 }
      );
      io.observe(root);
    }

    root.dataset.compareReady = 'true';
  }

  function boot() {
    document.querySelectorAll('[data-axiom-compare]').forEach(initCompare);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-axiom-compare]');
    if (root) {
      delete root.dataset.compareReady;
      initCompare(root);
    }
  });
})();
